import { httpClient } from '../../../httpClient';

import { IHomeResponse } from './models';

export const getHome = (): Promise<IHomeResponse> => {
    return httpClient.get('home');
};
